import { useSelector } from "react-redux";
import { getSheetDataState } from "./selectors";
import { CalcTableType, CalcType } from "mortar/Principal/Enums";

const useSheetCalcInfo = () => {
  const { includeStandardCalcTable, includeSoftwareCalcTable, calcType } =
    useSelector(getSheetDataState) ?? {};

  return {
    includeStandardCalcTable,
    includeSoftwareCalcTable,
    isMssa: calcType === CalcType.LegalServicesContract,
  };
};

export default useSheetCalcInfo;
